module.exports = __webpack_public_path__ + "static/media/green_leaves.24b226a4.png";